var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTzc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_33008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#374851"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95625 8.6625V12.9364C10.071 12.9082 10.1835 12.8762 10.2937 12.8391V14.4759C9.55594 14.6495 8.79071 14.6727 8.04375 14.544V8.6625H6.075V7.0875H11.925V8.6625H9.95625ZM10.7438 14.3494V12.6562C11.573 12.2607 12.2431 11.5949 12.644 10.7682C13.045 9.9415 13.1529 9.00306 12.9501 8.10694C12.7473 7.21082 12.2459 6.41029 11.5281 5.83678C10.8103 5.26327 9.91878 4.95087 9 4.95087C8.08122 4.95087 7.18975 5.26327 6.47195 5.83678C5.75414 6.41029 5.25268 7.21082 5.04989 8.10694C4.84709 9.00306 4.95502 9.9415 5.35595 10.7682C5.75689 11.5949 6.42699 12.2607 7.25625 12.6562V14.3494C5.00344 13.6153 3.375 11.4975 3.375 9C3.375 5.89331 5.89331 3.375 9 3.375C12.1067 3.375 14.625 5.89331 14.625 9C14.625 11.4975 12.9966 13.6153 10.7438 14.3494Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_33008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTzc);
export default __webpack_public_path__ + "static/media/tzc.33f23765d2dda45b2ce4c7f06b1e54c2.svg";
export { ForwardRef as ReactComponent };